import React, { Component } from "react";

export default class CustomerUserList extends Component {
  render() {
    let { customerRequestList, handleSwitchUser, requestCount } = this.props;
    return (
      <div className="col-md-3">
        <div className="customerOutletTransferContainer">
          <h6 className="title">Today Transfers:</h6>
          {requestCount && (
            <div className="customerStatusList">
              <h6 className="statustitle titleFontBold">
                {requestCount?.requests} Requests
              </h6>
              <h6 className="statustitle">
                {requestCount?.approved_count} Approvals
              </h6>
              <h6 className="statustitle">
                {requestCount?.rejected_count} Rejects
              </h6>
              <h6 className="statustitle">
                {requestCount?.pending_count} Pending
              </h6>
            </div>
          )}
        </div>
        <div className="customerUserListContainer">
          {customerRequestList &&
            Object.keys(customerRequestList).map((data) => {
              return (
                <div key={data}>
                  {customerRequestList[data].map((item) => {
                    let colorCode =
                      item.req_status === "Waiting"
                        ? "waitingColor"
                        : item.req_status === "Approved"
                        ? "ApprovedColor"
                        : "RejectedColor";
                    return (
                      <div
                        key={item.id}
                        className={`customerUserBox ${colorCode} cursor-pointer`}
                        onClick={() => handleSwitchUser(item)}
                      >
                        <div>
                          <h6 className="customerName">{item.cust_name}</h6>
                        </div>
                        {item.from_site && (
                          <div>
                            <h6 className="customerName">{item.from_site}</h6>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          {customerRequestList &&
            Object.keys(customerRequestList).length === 0 && (
              <div className="outletEmptyContainer">
                <h6>No Record Found</h6>
              </div>
            )}
        </div>
      </div>
    );
  }
}
